import { UserSelectorAvatar } from '@/shared/components/user-selector/UserSelectorAvatar';
import { GoalProgressNavigation } from './GoalProgressNavigation';
import type { Employee } from '@momentum/types';

interface GoalProgressHeaderProps {
  currentIndex: number;
  totalGoals: number;
  employee?: Employee;
  onPrevious: () => void;
  onNext: () => void;
  isLastGoal: boolean;
}

export const GoalProgressHeader = ({
  currentIndex,
  totalGoals,
  employee,
  onPrevious,
  onNext,
  isLastGoal,
}: GoalProgressHeaderProps) => {
  const employeeName = employee
    ? `${employee.personalInfo.firstName} ${employee.personalInfo.lastName}`
    : '';

  return (
    <div className="rounded-xl border border-gray-200 bg-white px-6 py-5 shadow-md">
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 md:gap-6">
        {employee && (
          <div className="flex items-center gap-4">
            <div className="flex h-[56px] w-[56px] shrink-0 items-center justify-center overflow-hidden rounded-xl border border-gray-200 bg-gray-50">
              <UserSelectorAvatar
                fullName={employeeName}
                imageUrl={employee.personalInfo.imageUrl}
                size="lg"
                shape="square"
              />
            </div>
            <div>
              <p className="text-lg font-semibold text-slate-900">
                {employeeName}
              </p>
            </div>
          </div>
        )}

        <GoalProgressNavigation
          currentIndex={currentIndex}
          totalGoals={totalGoals}
          onPrevious={onPrevious}
          onNext={onNext}
          isLastGoal={isLastGoal}
        />
      </div>
    </div>
  );
};
